<script setup>
import {ref, watch} from 'vue'
import { storeToRefs } from "pinia";
import { useFVStore } from '../../../stores/formvibes';
import { ArrowDown, User, PieChart, WarnTriangleFilled, Delete } from '@element-plus/icons-vue';
import { axiosPost } from '../../../Axios/post';
import { ElNotification } from 'element-plus';
// import Delete from './delete.vue';
// import notification css 
import 'element-plus/theme-chalk/src/notification.scss';

const props = defineProps(['row']);
const store= useFVStore();
const { user_capability: userCapability } = window.fvGlobalVar;
const { DeleteNote } = store;
const { notes, isLoading, notice } = storeToRefs(store);
const rowNotes = ref([]);
const open = ref(false)
const plugin_url = window.fvGlobalVar.plugin_url;

// watch([notes],() => {
//     rowNotes.value = notes.value[props.row.id];
// })

// const showDialog = ref(false);



</script>

<template>
    <div class="fv-notes-wrapper" v-if="notes[row.id].length > 0" >
        <div style="width: 100%">
            <ul class="fv-notes">
                <li class="fv-note-row">
                    <h4 @click="open = !open">
                    <div class="fv-note-heading">
                        <el-badge :value="notes[row.id].length" class="note-heading-bagde" color="green" :offset=[0,16]> 
                            <el-button class="panle-note-section-heading">Notes</el-button>
                        </el-badge>
                    </div>
                    <el-icon class="fv-icon-arrow"><ArrowDown /></el-icon>
                    </h4>
                    <div class="fv-note-row-content" :class="open ? 'show ': 'hide'">
                        <div class="fv-p-4 fv-note-list-wrapper">
                            <el-timeline style="max-width: 600px">
                                <el-timeline-item 
                                        hide-timestamp="false" 
                                        center 
                                        placement="top" 
                                        v-for="({note,author_name: authorName, is_me: isMe, date},index) in notes[row.id]" 
                                        :key="index" 
                                        :timestamp="date" 
                                        :icon="PieChart">
                                    <el-card>
                                        <div class="note-content-wrap">
                                            <span class="fv-note-author">{{isMe ? 'You' : authorName}}</span>
                                            <span class="fv-note-timestamp">Commented On {{date}}</span>
                                            <span class="fv-note-message">{{note}}</span>
                                            <el-button type="danger" :icon="Delete" circle  class="fv-delete-note" @click="DeleteNote(row.id,index,notes[row.id].length)"/>
                                        </div>
                                    </el-card>
                                </el-timeline-item>
                            </el-timeline>
                        </div>
                    </div>
                </li>
            </ul>
        </div>
        </div>
</template>